import styled from 'styled-components';
import { DefaultButton } from './DefaultButton';

export const TransparentButton = styled(DefaultButton)`
  background-color: transparent;
  border: 1px solid transparent;
  color: ${({ theme }) => theme.COLORS.textDark};
  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.COLORS.textLight};
  }
`;
